import { DOCUMENT } from '@angular/common';
import { Directive, effect, ElementRef, inject, Injector, input, OnInit, Renderer2, untracked } from '@angular/core';

@Directive({
  selector: 'ls-modal, ls-alert',
  standalone: true
})
export class OverlayPortal implements OnInit {
  readonly #document = inject(DOCUMENT);
  readonly #injector = inject(Injector);
  readonly #elementRef = inject(ElementRef);
  readonly #renderer = inject(Renderer2);

  readonly visible = input.required<boolean>();

  ngOnInit() {
    const hostElement = this.#elementRef.nativeElement;
    const { firstChild, parentNode, nextSibling } = hostElement;

    this.initAttachVisibleElementEffect(hostElement);
    this.initOpacityTransitionEndEventListener(hostElement, firstChild, parentNode, nextSibling);
  }

  private initAttachVisibleElementEffect(hostElement: HTMLElement) {
    effect(
      () => {
        const isVisible = this.visible();

        untracked(() => isVisible && this.attachElement(hostElement));
      },
      { injector: this.#injector }
    );
  }

  private initOpacityTransitionEndEventListener(
    hostElement: HTMLElement,
    hostElementFirstChild: HTMLElement,
    hostElementParent: HTMLElement,
    hostElementNextSibling: HTMLElement
  ) {
    this.#renderer.listen(
      hostElementFirstChild,
      'transitionend',
      ({ propertyName }: TransitionEvent) =>
        propertyName === 'opacity' && this.detachElement(hostElement, hostElementParent, hostElementNextSibling)
    );
  }

  private attachElement(hostElement: HTMLElement) {
    this.#renderer.appendChild(this.#document.body, hostElement);
  }

  private detachElement(hostElement: HTMLElement, hostElementParent: HTMLElement, hostElementNextSibling: HTMLElement) {
    this.#renderer.insertBefore(hostElementParent, hostElement, hostElementNextSibling);
  }
}
